export default __webpack_public_path__ + "static/media/fontMulish800_latin.53421642.woff2";